module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ((_vm.$route.name == 'Tasks') ? _vm.settingsLinkActiveClass : ''),
    attrs: {
      "to": {
        name: 'Tasks',
        query: {
          taskmaster_id: _vm.$store.state.users.current.id
        }
      }
    }
  }, [_c('span', [_vm._v("Мои задачи (создатель)")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ((_vm.$route.name == 'Tasks') ? _vm.settingsLinkActiveClass : ''),
    attrs: {
      "to": {
        name: 'Tasks',
        query: {
          responsible_id: _vm.$store.state.users.current.id,
          responsible: _vm.$store.state.users.current.login
        }
      }
    }
  }, [_c('span', [_vm._v("Мои задачи (исполнитель)")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6ef424a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tasks/menus/FavoritesMenu.vue
// module id = 1270
// module chunks = 0